import { axiosInstance } from "@src/api/axiosConfig";
import { axiosPath } from "@src/api/axiosPath";
import { SubmitDeungiRequestDto } from "./dto/Deungi.dto";

export const useDeungiRetry = async (id: string) => {
    const response = await axiosInstance.post(`${axiosPath.retryDeungi}`, {id});
    return response;
};
